export default "__VITE_ASSET__BjxKdBrQ__"